import { atom } from 'recoil';

export const isTermsAndConditionsOpenAtom = atom({
  key: 'isTermsAndConditionsOpenAtom',
  default: false,
});
